import { Icon } from "@iconify/react"
import { copyToClipboard } from "../../../utils"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

interface InitQr {
    qrPngBase64: string;
    secretBase32: string;
}

interface QrStepProps {
    initQr: InitQr | null;
    handleNext: () => void;
}

const QrStep = ({ initQr, handleNext }: QrStepProps) => {
    const { t } = useTranslation()
    return (
        <>
            <img
                src={`data:image/png;base64,${initQr?.qrPngBase64}`}
                alt="2FA QR code"
                className="qr-2fa-img"
            />
            <button
                type="button"
                className="two-factor-copy-button"
                onClick={() => copyToClipboard(initQr?.secretBase32 ?? "")}
            >
                <Icon icon="solar:copy-outline" width={18} /> {t("copyAuthenticatorKey")}
            </button>

            <button
                className="two-factor-qr-button"
                onClick={handleNext}
                disabled={!initQr?.qrPngBase64}
            >
                {t("next")}
            </button>

            <Link to="/login" className="loginLink">
                {t("goTologin")}
            </Link>
        </>
    )
}

export default QrStep
